import { render, staticRenderFns } from "./FullscreenImageViewer.vue?vue&type=template&id=3556ca82&scoped=true&"
import script from "./FullscreenImageViewer.vue?vue&type=script&lang=js&"
export * from "./FullscreenImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./FullscreenImageViewer.vue?vue&type=style&index=0&id=3556ca82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3556ca82",
  null
  
)

export default component.exports